import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { NavbarComponent } from '@/app/layouts/public-layout/navbar/navbar';
import { PublicFooterComponent } from '@/app/layouts/public-layout/footer/footer';
import { LanguageFacade } from '@/app/core/language/facades/language.facade';
import { PublicConfigService } from '@/app/core/config/public-config.service';
import { ToastService } from '@/app/core/services/toast/toast.service';
import { AlertComponent } from '@/app/features/basic-components/alert/alert';
import { QuotationProgressToastComponent } from '@/app/features/general-components/toasts/quotation-progress-toast/quotation-progress-toast';

@Component({
  selector: 'app-public-layout',
  standalone: true,
  imports: [RouterOutlet, NavbarComponent, PublicFooterComponent, AlertComponent, QuotationProgressToastComponent],
  templateUrl: './public-layout.html',
  styleUrl: './public-layout.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PublicLayoutComponent {
  private readonly languageFacade = inject(LanguageFacade);
  private readonly publicConfig = inject(PublicConfigService);
  readonly toastService = inject(ToastService);

  constructor() {
    this.publicConfig.load();
  }
}
